export default function copyText(id) {
  navigator.clipboard.writeText(document.getElementById(id).value)
}
